import EventEditPageHeader from './EventEditPageHeader';

export default EventEditPageHeader;
